export class NameColor {
  name: string;
  color: number;
  ofPeerId: string;

  constructor(name: string, color: number, ofPeerId: string) {
    this.name = name;
    this.color = color;
    this.ofPeerId = ofPeerId;
  }
}
